import ChangelogItemController from "./changelog-item-controller";
import { connect } from "react-redux";
import { compose } from "redux";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { getValue } from 'store/languages';
import { getChangeLogs, updateChangelog, setIsChangelogUpdated, createChangelog, deleteChangelog, getChangeLog, setChangeLog } from "store/change-log";
import { setRightMenuComponent, setShowRightMenu, setRemoveRightMenuComponent } from "store/side-bar";
 
let mapStateToProps = (state) => {
    return {
        changeLog: state.ChangeLog.changeLog,
        notificationsTypes: state.ChangeLog.notificationsTypes,
        selectedLanguage: state.languages.selectedLanguage,
        showedItemsCount: state.paginator.showedItemsCount,
        currentPage: state.paginator.currentPage,
    }
}

const ChangelogItemContainer = connect(mapStateToProps, {     
                                                        getValue,
                                                        createChangelog, updateChangelog,
                                                        setRightMenuComponent, setShowRightMenu, setRemoveRightMenuComponent,
                                                        setChangeLog
                                    })(ChangelogItemController)

export default ChangelogItemContainer;